import {gql} from 'graphql-tag';

export const DELETE_NOTIFICATION = gql`
  mutation deleteNotification($id: ID!) {
    deleteNotification(id: $id)
  }
`;